<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          {{ file ? 'Update' : 'Add' }} Quiz
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Quiz Name">
          <d-input v-model="form.name" />
        </d-field>
        <d-field label="Quiz Pass Percentage">
          <d-input v-model.number="quizPassPercentage" type="number" step="any" />
        </d-field>
        <d-field label="Lock on Passing Score">
          <input v-model="form.lockOnPass" type="checkbox" />
        </d-field>
        <d-field label="Post-Attempt Feedback">
          <d-select v-model="form.quizFeedbackMode" expanded>
            <option :value="QuizFeedbackMode.NONE">No feedback beyond pass/fail</option>
            <option :value="QuizFeedbackMode.INDICATE_CORRECTNESS">Indicate which questions were correct/incorrect</option>
            <option :value="QuizFeedbackMode.SHOW_CORRECT_ANSWERS">Show correct/incorrect and display correct answers</option>
          </d-select>
        </d-field>
        <d-field label="Quiz Passscode (optional)">
          <d-input v-model="form.password"/>
        </d-field>
        <d-field label="Description">
          <l-html-editor v-model="form.description" />
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$emit('close')">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          {{ file ? 'Update' : 'Add' }} Quiz
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>
  import { createItem, updateItem } from '@resources/scripts/services/contentListingItemsApi.service';
  import { ListingItemType, QuizFeedbackMode } from '@resources/scripts/constants';
  import { showErrorToast } from '@services/errorHandling.service';

  export default {
    props: {
      contentListing: {
        type: Object,
        default: () => ({}),
      },

      file: {
        type: Object,
        default: null,
      },
    },

    emits: ['close', 'saved'],

    data() {
      return {
        saving: false,
        QuizFeedbackMode,
        form: {
          name: '',
          description: '',
          content: 'Quiz',
          categorized: true,
          quizPassPercentage: 1,
          lockOnPass: true,
          quizFeedbackMode: QuizFeedbackMode.NONE,
          password: '',
          type: ListingItemType.QUIZ,
        },
      };
    },

    computed: {
      quizPassPercentage: {
        get: (vm) => vm.form.quizPassPercentage * 100,
        set(val) {
          this.form.quizPassPercentage = val / 100;
        },
      },
    },

    mounted() {
      if (this.file) {
        this.form = JSON.parse(JSON.stringify(this.file));
        if (this.form.quizFeedbackMode == null) {
          this.form.quizFeedbackMode = QuizFeedbackMode.NONE;
        }
      }
    },

    methods: {
      async saveForm() {
        this.saving = true;
        try {
          if (this.file) {
            await updateItem(this.form.id, this.form, this.contentListing.type);
          } else {
            await createItem(this.form, this.contentListing.id, this.contentListing.type);
          }
          this.$emit('saved');
          this.$emit('close');
        } catch (error) {
          showErrorToast(error);
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>